import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from '~/ui/components/inputs/Select';
import { CODE_TYPE_OPTIONS } from '../constants';
import { IOption } from '~/ui/components/inputs/Select/types';

interface IProps {
  index: number;
  isDeletable: boolean;
  icd10CodeOptions: IOption[];
  onRemove?: (index: number) => void;
}

const CarePlanIcd10Code = ({
  index,
  isDeletable,
  icd10CodeOptions,
  onRemove,
}: IProps): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={3} alignItems="center">
      <Grid item xs>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <Select
              name={`carePlanIcd10Codes.${index}.typeId`}
              label="Type"
              required
              options={CODE_TYPE_OPTIONS}
              control={control}
              errors={errors}
              isInBody
            />
          </Grid>
          <Grid item xs={9}>
            <Select
              name={`carePlanIcd10Codes.${index}.icd10CodeId`}
              label="Code"
              required
              options={icd10CodeOptions}
              control={control}
              errors={errors}
              isInBody
            />
          </Grid>
        </Grid>
      </Grid>
      {isDeletable && (
        <Grid item>
          <IconButton title="Remove" onClick={() => onRemove(index)}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default CarePlanIcd10Code;
